"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var FormLabel = function (_a) {
    var _b = _a.children, children = _b === void 0 ? '' : _b, classes = _a.classes, color = _a.color, _c = _a.component, component = _c === void 0 ? 'label' : _c, disabled = _a.disabled, error = _a.error, filled = _a.filled, focused = _a.focused, required = _a.required;
    return (react_1.default.createElement(FormLabel_1.default, { classes: classes, color: color, component: component, disabled: disabled, error: error, filled: filled, focused: focused, required: required }, children));
};
exports.default = FormLabel;
